/*
 * When the browser restores a page from its back/forward cache (e.g. Back from checkout),
 * the cart drawer and cart page still show the cart as it was when the page was left.
 * Their line numbers no longer match the real cart, so quantity changes and removals fail
 * with "line parameter is invalid". Re-render them from the current cart instead.
 */
(() => {
  const DRAWER_SECTIONS = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];

  const sectionInnerHTML = (html) =>
    new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section')?.innerHTML;

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;

    // The cart page renders the cart in several sections; a reload is the simplest correct refresh.
    // (The drawer reuses the id "main-cart-items", so detect the cart page by URL.)
    if (window.location.pathname === window.theme?.routes?.cart_url) {
      window.location.reload();
      return;
    }

    const url = `${window.location.pathname}?sections=${DRAWER_SECTIONS.join(',')}`;
    fetch(url)
      .then((response) => response.json())
      .then((sections) => {
        DRAWER_SECTIONS.forEach((id) => {
          const element = document.getElementById(id);
          const html = sections[id] && sectionInnerHTML(sections[id]);
          if (element && html) element.innerHTML = html;
        });
      })
      .catch((error) => console.error(error));
  });
})();
